import { useSearchParams } from "react-router"
import { useSubstanceAudit } from "../../../api/substancesApi"
import { AuditTrail } from "../../shared/AuditTrail"

export function SubstanceAuditSection() {
  const [searchParams] = useSearchParams()
  const substanceId = searchParams.get("id")

  const { data, hasNextPage, fetchNextPage, isLoading, isFetchingNextPage } =
    useSubstanceAudit(substanceId, { limit: 20 })

  const events = data?.pages.flatMap((p) => p.items) ?? []

  return (
    <AuditTrail
      events={events}
      isLoading={isLoading}
      hasMore={!!hasNextPage}
      isFetchingMore={isFetchingNextPage}
      onLoadMore={fetchNextPage}
    />
  )
}
